import * as Yup from "yup";

export const taxesValidationSchema = (translate: (text:string)=>string) =>
  Yup.object().shape({
    code: Yup.string().required(translate("code_is_required")),
    description: Yup.string().nullable().optional(),
    taxType: Yup.string().required(translate("tax_type_required")),
    rate: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .required(translate("rate_required"))
      .min(0, translate("rate_min")),
    isWithholdingTax: Yup.boolean().default(false),
    isActive: Yup.boolean().default(true),
  });
